import { Copy, Flex, Stack, SvgInfo } from '@grubhubprod/gh-cookbook-react';
import React from 'react';

export const LineOfCreditCardAssignPeople: React.FC = () => (
  <Copy variant="body" color="warning">
    <Flex alignItems="center">
      <Stack y="xxx-sm" x="xxx-sm">
        <SvgInfo />
      </Stack>
      Assign people
    </Flex>
  </Copy>
);
